module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc1-03-a5ed094326026abbf0117914ca5b88f2.png";